const BASE_URL: string = '/';

/**
 * 
 */
export const DASHBOARD_PATH = {

  DASHBOARD: BASE_URL,
}